import { render, staticRenderFns } from "./WineShow.vue?vue&type=template&id=e22f5428&"
import script from "./WineShow.vue?vue&type=script&lang=js&"
export * from "./WineShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports